import * as React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import CheckoutAdditionalServiceComponent from '@websky/core/src/CheckoutAdditionalService/CheckoutAdditionalService/CheckoutAdditionalService';
import { AdditionalServiceType } from '@websky/core/src/CheckoutAdditionalService/types';
import { getBusinessLounge, getOrder, getPriorityBoarding } from '@websky/core/src/Checkout/store/order/selectors';
import Button from '@websky/core/src/Button';
import Switch from '@websky/core/src/Switch';
import css from './CheckoutAdditionalService.css';
import { getIatasByServices } from './utils';
const CheckoutAdditionalService = props => {
    var _a, _b;
    const { t } = useTranslation('CheckoutAdditionalService');
    const order = useSelector(getOrder);
    const businessLoungeServices = useSelector(getBusinessLounge);
    const priorityServices = useSelector(getPriorityBoarding);
    const isBusinessLounge = props.serviceType === AdditionalServiceType.BusinessLounge;
    const isPriorityBoarding = props.serviceType === AdditionalServiceType.PriorityBoarding;
    const isInsurance = props.serviceType === AdditionalServiceType.Insurance;
    let iatas = [];
    if (isBusinessLounge) {
        iatas = getIatasByServices(businessLoungeServices, order.flight.segments);
    }
    if (isPriorityBoarding) {
        iatas = getIatasByServices(priorityServices, order.flight.segments);
    }
    const renderControls = (props) => {
        var _a;
        return (React.createElement("div", { className: css.controls },
            props.isSelected &&
                ((_a = props.buttons) === null || _a === void 0 ? void 0 : _a.map(button => {
                    const isChangeButton = button.buttonType === 'change';
                    return (React.createElement(Button, { key: button.text, isLoading: button.isLoading, onClick: button.action, variant: "text", size: "common" },
                        button.text,
                        isChangeButton && (React.createElement(Switch, { mainClassName: css.switchContainer, activeClassName: css.switchContainer__active, labelClassName: css.switchContainer__label, label: "", isActive: true }))));
                })),
            !props.isSelected && props.showAddButton !== false && (React.createElement(Button, { className: css.add, variant: "text", isLoading: props.isLoading, onClick: props.addClick },
                props.addButtonText ? t(props.addButtonText) : t('Add'),
                React.createElement(Switch, { mainClassName: css.switchContainer, labelClassName: css.switchContainer__label, label: "", isActive: false })))));
    };
    return (React.createElement(CheckoutAdditionalServiceComponent, Object.assign({}, props, { className: cn(props.className, {
            [css.business]: isBusinessLounge,
            [css.priorityBoarding]: isPriorityBoarding,
            [css.bg_zia]: iatas.includes('ZIA'),
            [css.bg_aer]: iatas.includes('AER')
        }), header: isPriorityBoarding ? (_b = (_a = priorityServices[0]) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : props.header : props.header, priceFrom: isPriorityBoarding ? (props.isSelected ? props.priceFrom : null) : props.priceFrom, renderControls: renderControls, hideFrom: isInsurance && props.servicesCount <= 1 })));
};
export default CheckoutAdditionalService;
